// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ToneArchetypeStep — onboarding card picker */

.tone-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    padding: 2rem 1rem;
    max-width: 780px;
    margin: 0 auto;
}

.tone-step-header {
    text-align: center;
}

.tone-step-header h2 {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.tone-step-subtitle {
    color: var(--text-secondary, #6b7280);
    font-size: 0.95rem;
    max-width: 520px;
}

.tone-step-error {
    background: #fee2e2;
    color: #dc2626;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    width: 100%;
    text-align: center;
}

/* 3-col grid on wide screens, 2-col on medium, 1-col on small */
.archetype-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    width: 100%;
}

@media (max-width: 640px) {
    .archetype-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 400px) {
    .archetype-grid {
        grid-template-columns: 1fr;
    }
}

.archetype-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
    padding: 1rem;
    border: 2px solid var(--border-color, #e5e7eb);
    border-radius: 12px;
    background: var(--card-bg, #ffffff);
    cursor: pointer;
    text-align: left;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.1s;
}

.archetype-card:hover {
    border-color: var(--primary, #6366f1);
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);
}

.archetype-card.selected {
    border-color: var(--primary, #6366f1);
    background: var(--primary-light, #eef2ff);
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
    transform: translateY(-1px);
}

.archetype-icon {
    font-size: 1.75rem;
    line-height: 1;
}

.archetype-label {
    font-weight: 700;
    font-size: 0.95rem;
    color: var(--text-primary, #111827);
}

.archetype-tagline {
    font-size: 0.82rem;
    color: var(--primary, #6366f1);
    font-style: italic;
}

.archetype-description {
    font-size: 0.78rem;
    color: var(--text-secondary, #6b7280);
    line-height: 1.4;
    margin-top: 0.15rem;
}

.tone-step-notice {
    font-size: 0.82rem;
    color: var(--text-secondary, #6b7280);
    text-align: center;
}

/* Primary button (reuses global .btn if available; fallback below) */
.tone-step .btn-primary {
    min-width: 220px;
    padding: 0.75rem 2rem;
    font-size: 1rem;
}

.tone-loading {
    display: flex;
    justify-content: center;
    padding: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/components/onboarding/ToneArchetypeStep.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA,gEAAgE;AAChE;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,8DAA8D;AAClE;;AAEA;IACI,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,yCAAyC;IACzC,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA,qEAAqE;AACrE;IACI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB","sourcesContent":["/* ToneArchetypeStep — onboarding card picker */\n\n.tone-step {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n    padding: 2rem 1rem;\n    max-width: 780px;\n    margin: 0 auto;\n}\n\n.tone-step-header {\n    text-align: center;\n}\n\n.tone-step-header h2 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    margin-bottom: 0.5rem;\n}\n\n.tone-step-subtitle {\n    color: var(--text-secondary, #6b7280);\n    font-size: 0.95rem;\n    max-width: 520px;\n}\n\n.tone-step-error {\n    background: #fee2e2;\n    color: #dc2626;\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n    font-size: 0.9rem;\n    width: 100%;\n    text-align: center;\n}\n\n/* 3-col grid on wide screens, 2-col on medium, 1-col on small */\n.archetype-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem;\n    width: 100%;\n}\n\n@media (max-width: 640px) {\n    .archetype-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 400px) {\n    .archetype-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.archetype-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n    padding: 1rem;\n    border: 2px solid var(--border-color, #e5e7eb);\n    border-radius: 12px;\n    background: var(--card-bg, #ffffff);\n    cursor: pointer;\n    text-align: left;\n    transition: border-color 0.2s, box-shadow 0.2s, transform 0.1s;\n}\n\n.archetype-card:hover {\n    border-color: var(--primary, #6366f1);\n    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);\n}\n\n.archetype-card.selected {\n    border-color: var(--primary, #6366f1);\n    background: var(--primary-light, #eef2ff);\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);\n    transform: translateY(-1px);\n}\n\n.archetype-icon {\n    font-size: 1.75rem;\n    line-height: 1;\n}\n\n.archetype-label {\n    font-weight: 700;\n    font-size: 0.95rem;\n    color: var(--text-primary, #111827);\n}\n\n.archetype-tagline {\n    font-size: 0.82rem;\n    color: var(--primary, #6366f1);\n    font-style: italic;\n}\n\n.archetype-description {\n    font-size: 0.78rem;\n    color: var(--text-secondary, #6b7280);\n    line-height: 1.4;\n    margin-top: 0.15rem;\n}\n\n.tone-step-notice {\n    font-size: 0.82rem;\n    color: var(--text-secondary, #6b7280);\n    text-align: center;\n}\n\n/* Primary button (reuses global .btn if available; fallback below) */\n.tone-step .btn-primary {\n    min-width: 220px;\n    padding: 0.75rem 2rem;\n    font-size: 1rem;\n}\n\n.tone-loading {\n    display: flex;\n    justify-content: center;\n    padding: 3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
